import { transformRoutes } from '../utils'

const baseRoute = '/shifts-creation'

export const ShiftsCreationAreaRoutes = transformRoutes({
  route: baseRoute,
})
